export default __webpack_public_path__ + "static/media/SavedSearchesIconActive.b74b6322.svg";